module.exports = __webpack_public_path__ + "media/images/front/toplogo_sp-3956b7a07a42eaeec0abcededde5e434.png";